<template>
    <section class="providers mb-2 py-5">
        <h2 class="text-center mb-5">{{ title }}</h2>
        <div class="container position-relative">
            <div class="row">
                <div class="col-12 mb-5">
                    <div
                        ref="slider__controls"
                        class="slider__controls"
                        aria-label="Theme slider"
                        tabindex="0"
                    >
                        <a
                            class="prev"
                            aria-controls="customize"
                            data-controls="prev"
                            tabindex="-1"
                            ><i
                                class="fa fa-chevron-left color--purple-1"
                                aria-hidden="true"
                            ></i
                        ></a>
                        <a
                            class="next"
                            aria-controls="customize"
                            data-controls="next"
                            tabindex="-1"
                            ><i
                                class="fa fa-chevron-right color--purple-1"
                                aria-hidden="true"
                            ></i
                        ></a>
                    </div>
                    <div ref="slider" class="provider-slider">
                        <provider-card
                            v-for="(card, index) in cards"
                            :key="index"
                            class="mb-2"
                            :card="card"
                        ></provider-card>
                    </div>
                </div>
                <div v-if="button" class="col-12 text-center mb-5">
                    <a :href="button.Url" :target="button.Target" class="btn"
                        ><span
                            >{{ button.Name }}
                            <i
                                class="fa fa-arrow-right ml-2"
                                aria-hidden="true"
                            ></i
                        ></span>

                        ></a
                    >
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import providerCard from '@/components/cards/provider-card';
export default {
    components: {
        providerCard
    },

    props: {
        slides: {
            type: Number,
            default: 8
        },
        cards: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default: ''
        },
        button: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            slider: ''
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1,
                controlsContainer: this.$refs.slider__controls,
                slideBy: 1,
                mouseDrag: false,
                swipeAngle: false,
                lazyload: false,
                nav: false,
                autoplayButton: false,
                autoplayButtonOutput: false,
                preventScrollOnTouch: 'auto',
                speed: 400,
                responsive: {
                    768: {
                        items: 2,
                        gutter: 30
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss">
@include media-breakpoint-up(lg) {
    .tns-ovh {
        margin: 0 -15px;
    }

    .tns-inner {
        padding: 0 15px;
    }
}
</style>

<style lang="scss" scoped>
.slider__controls {
    position: absolute;
    height: 100%;
    width: 100%;
    display: block;
    left: 0;
}

.prev {
    position: absolute;
    left: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        left: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        left: -40px;
    }
}

.next {
    position: absolute;
    right: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        right: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        right: -40px;
    }
}
</style>
